if($('.in-index').length){
    $('.products').each(function(){
        if($('footer#footer .homepageBanners[data-id="'+$(this).attr('data-testid')+'"]').length){
            $(this).append($('footer#footer .homepageBanners[data-id="'+$(this).attr('data-testid')+'"]>div'))
        }
    })
}